import { useEffect } from 'react';
import { UnitEmergencyDto } from '@mark43/cad-api';
import { useAudibleAlerts } from '../sounds/play-sound-provider';
import { usePrevious } from '../common/hooks/use-previous';

export function useHandleUnitEmergencySoundAlert({
    filteredUnAckedUnitEmergencies,
}: {
    filteredUnAckedUnitEmergencies: UnitEmergencyDto[];
}) {
    const { playAlert } = useAudibleAlerts();
    const previousFilteredUnAckedUnitEmergencies = usePrevious(filteredUnAckedUnitEmergencies);

    useEffect(
        function playEmergencyAlertWhenOneArrives() {
            if (!filteredUnAckedUnitEmergencies?.length) {
                return;
            }

            if (
                !previousFilteredUnAckedUnitEmergencies ||
                filteredUnAckedUnitEmergencies.length >
                    previousFilteredUnAckedUnitEmergencies.length
            ) {
                playAlert({ type: 'EMERGENCY' });
            }
        },
        [filteredUnAckedUnitEmergencies, previousFilteredUnAckedUnitEmergencies, playAlert]
    );
}
